<script setup lang="ts">
/**
 * CDB54 Calendrier+ - Accessibility Settings Component
 * Story 2.7c: Font size adjustment
 */

import { useAccessibility, type FontSize } from '@/composables/useAccessibility';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const { fontSize, setFontSize, getFontSizeOptions } = useAccessibility();

const fontSizeOptions = getFontSizeOptions();

function handleFontSizeChange(event: Event): void {
  const target = event.target as HTMLSelectElement;
  setFontSize(target.value as FontSize);
}
</script>

<template>
  <div class="accessibility-settings">
    <label :for="'font-size-select'" class="form-label small">
      <i class="bi bi-text-paragraph me-1"></i>
      {{ t('accessibility.font_size') }}
    </label>
    <select
      id="font-size-select"
      class="form-select form-select-sm"
      :value="fontSize"
      @change="handleFontSizeChange"
      :aria-label="t('accessibility.font_size_label')"
    >
      <option
        v-for="option in fontSizeOptions"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<style scoped>
.accessibility-settings {
  min-width: 180px;
}
</style>
